import { connect } from "react-redux";
import FlatFile from "./FlatFile";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FlatFile);
